__turbopack_context__.v({
  "buttons": "xWDs_G_buttons",
  "container": "xWDs_G_container",
  "error": "xWDs_G_error",
  "icon": "xWDs_G_icon",
  "input": "xWDs_G_input",
  "isActive": "xWDs_G_isActive",
  "isError": "xWDs_G_isError",
  "isHidden": "xWDs_G_isHidden",
  "isMedium": "xWDs_G_isMedium",
  "isSmall": "xWDs_G_isSmall",
  "label": "xWDs_G_label",
  "list": "xWDs_G_list",
  "placeholder": "xWDs_G_placeholder",
  "popup": "xWDs_G_popup",
  "select": "xWDs_G_select",
  "valueContainer": "xWDs_G_valueContainer",
});
